module.exports = __webpack_public_path__ + "img/picto-tab-emotionnel.002ab7c6.svg";